import { render, staticRenderFns } from "./SendDiscount.vue?vue&type=template&id=cd351700&scoped=true"
import script from "./SendDiscount.vue?vue&type=script&lang=js"
export * from "./SendDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd351700",
  null
  
)

export default component.exports